import { SetupUser } from '../../../index';
import { Component, computed, input, output, signal } from '@angular/core';
import { SvgIconsComponent } from '../svg-icons/svg-icons.component';
import { FormsModule } from '@angular/forms';

type UserWithInitials = SetupUser & {
  initials: string;
};
@Component({
  selector: 'app-user-list',
  imports: [SvgIconsComponent, FormsModule],
  templateUrl: './user-list.component.html'
})
export class UserListComponent {
  selectedUser = input<UserWithInitials | null>(null);
  usersInput = input<UserWithInitials[] | []>([]);
  searchable = input<boolean>(true);
  selectable = input<boolean>(true);
  userOutput = output<UserWithInitials | null>();
  searchTextUser = signal<string>('');

  // constructor() {
  //   effect(() => {
  //     const users = this.usersInput();
  //     if (users.length > 0 && !this.selectedUser()) {
  //       this.selectedUser.set(users[0]);
  //     }
  //   });
  // }

  usersListDisplay = computed(() =>
    this.usersList().filter((user: any) =>
      `${user.firstName} ${user.lastName}`?.toLowerCase().includes(this.searchTextUser()?.toLowerCase() ?? '')
    )
  );
  usersList = computed(() => this.usersInput());

  selectUser(user: UserWithInitials) {
    // this.selectedUser.set(user);
    // const selected = this.selectedUser();
    //   if (selected) {
    this.userOutput.emit(user);
    // }
  }
}
